import React from "react";
import { CardContent } from "@/components/ui/card";
import { CompanyForm } from "./CompanyForm";
import type { Company, CompanyFormData } from "@/types/company";

interface CompanyFormWrapperProps {
  onSubmit: (data: CompanyFormData) => void;
  initialData?: Company;
  onClear: () => void;
  isEditing: boolean;
}

export const CompanyFormWrapper = ({
  onSubmit,
  initialData,
  onClear,
  isEditing,
}: CompanyFormWrapperProps) => {
  return (
    <CardContent>
      <CompanyForm
        onSubmit={onSubmit}
        initialData={initialData}
        onClear={onClear}
        isEditing={isEditing}
      />
    </CardContent>
  );
};